import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { APIService } from "src/app/api/api.service";
import { NotifierService } from "src/app/_services/notifier.service";

@Component({
  selector: "app-patching-history-edit",
  templateUrl: "./patching-history-edit.component.html",
  styleUrls: ["./patching-history-edit.component.css"],
})
export class PatchingHistoryEditComponent implements OnChanges {
  @Input() accountId: string = "";
  @Input() environmentOptions: string[] = [];
  @Input() item: any = null;
  @Output() cancel = new EventEmitter<void>();
  @Output() updated = new EventEmitter<any>();

  saving = false;
  editForm: any = {
    environment: "",
    nextPatchingDateTime: "",
    toEmailCommunication: "",
    ccEmailCommunication: "",
  };

  constructor(
    private apiServer: APIService,
    private notifier: NotifierService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["item"]?.currentValue) {
      this.patchForm(changes["item"].currentValue);
    }
  }

  patchForm(item: any) {
    this.editForm = {
      environment: item?.environment || "",
      nextPatchingDateTime: this.formatDateTimeForInput(
        item?.next_patching_date_time
      ),
      toEmailCommunication: this.normalizeEmailsForInput(
        item?.to_email_communication
      ),
      ccEmailCommunication: this.normalizeEmailsForInput(
        item?.cc_email_communication
      ),
    };
  }

  closeEdit() {
    this.cancel.emit();
  }

  async updateRecord() {
    if (!this.item || !this.accountId) {
      return;
    }

    this.saving = true;
    this.notifier.loading(true);

    const payload = {
      action: "update",
      awsAccountId: this.accountId,
      hostname: this.item.hostname,
      updates: {
        environment: this.editForm.environment || null,
        nextPatchingDateTime: this.formatDateTimeForApi(
          this.editForm.nextPatchingDateTime
        ),
        toEmailCommunication: this.parseEmails(
          this.editForm.toEmailCommunication
        ),
        ccEmailCommunication: this.parseOptionalEmails(
          this.editForm.ccEmailCommunication
        ),
      },
    };

    const header = {
      Authorization: localStorage.getItem("t"),
    };

    const apiURL =
      "https://dev.api.swayam.cloud/v3/admin/apis/patching-fetch-save-config";

    const result = await this.apiServer.postDataPromis(apiURL, payload, header);

    if (result?.status === "success") {
      this.notifier.alert(
        "Success",
        "",
        "Patching info updated successfully.",
        "success",
        4000
      );
      this.updated.emit(result.item || {});
    } else {
      this.notifier.alert(
        "Error",
        "",
        result?.error || result?.msg || "Unable to update patching info.",
        "error",
        5000
      );
    }

    this.saving = false;
    this.notifier.loading(false);
  }

  normalizeEmailsForInput(value: any) {
    if (!value) {
      return "";
    }

    if (Array.isArray(value)) {
      return value.join(", ");
    }

    const rawValue = String(value).trim();
    if (rawValue.startsWith("[") && rawValue.endsWith("]")) {
      return rawValue
        .replace(/^\[/, "")
        .replace(/\]$/, "")
        .replace(/'/g, "")
        .split(",")
        .map((email: string) => email.trim())
        .filter((email: string) => !!email)
        .join(", ");
    }

    return rawValue;
  }

  parseEmails(value: string) {
    return (value || "")
      .split(",")
      .map((email: string) => email.trim())
      .filter((email: string) => !!email);
  }

  parseOptionalEmails(value: string) {
    const emails = this.parseEmails(value);
    return emails.length ? emails : null;
  }

  formatDateTimeForInput(value: string) {
    if (!value) {
      return "";
    }

    return String(value).replace(" ", "T");
  }

  formatDateTimeForApi(value: string) {
    if (!value) {
      return null;
    }

    return String(value).replace("T", " ");
  }
}
